import {Trans} from 'react-i18next';
import {ContactoPageType} from '~/services/GetPageContactService';
import {IconEmail} from './IconEmail';
import {IconMap} from './IconMap';
import {IconPhone} from './IconPhone';

export function Info({
  page,
  className,
}: {
  page: ContactoPageType;
  className?: string;
}) {
  return (
    <div className={className}>
      <iframe
        title="HPMLED"
        height={400}
        className="mb-12 w-full rounded-xl"
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={page.urlMap}
      />

      <div className="flex flex-col gap-6">
        <div className="flex gap-4 items-start">
          <IconMap />

          <div>
            <h2 className="font-bold uppercase">
              <Trans i18nKey="direccion" />
            </h2>
            <a
              href={page.urlDireccion}
              target="_blank"
              className="font-medium text-gray-500 hover:underline decoration-gray-500"
              rel="noreferrer"
            >
              {page.direccion}
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-6 xl:flex-row">
          <div className="flex flex-1 gap-4 items-start">
            <IconPhone />

            <div>
              <h2 className="font-bold uppercase">
                <Trans i18nKey="telefono" />
              </h2>
              <a
                href={page.urlTelefono}
                className="font-medium text-gray-500 hover:underline decoration-gray-500"
              >
                {page.telefono}
              </a>
            </div>
          </div>
          <div className="flex gap-4 items-start flex-">
            <IconEmail />

            <div>
              <h2 className="font-bold uppercase">
                <Trans i18nKey="correo-electronico" />
              </h2>
              <a
                href={page.urlEmail}
                className="font-medium text-gray-500 hover:underline decoration-gray-500"
              >
                {page.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
